import { GreenMarker as GreenMarkerImpl } from '@mm/components';
import React from 'react';
import { useFreeTrialUpgradeModal } from '../../modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';

type Props = {
  className?: string;
};
export const GreenMarker = ({ className }: Props) => {
  const { isFreeTrialPromotionWithoutSubscription } =
    useFreeTrialUpgradeModal();

  return isFreeTrialPromotionWithoutSubscription ? (
    <GreenMarkerImpl className={className} />
  ) : null;
};
